import { Box, LinearProgress } from "@mui/material"
import { useState } from "react"
import { ShareLinkDownloadProgress } from "event-definitions"

export function ShareLinkDownloadProgressSnackbar({ message, snackbarKey }) {
    const [percent, setPercent] = useState(0)

    ShareLinkDownloadProgress.useEvent(handleProgress, [snackbarKey])

    return (
        <Box data-cy={`share-link-download-progress-${snackbarKey}`} sx={{ width: 1 }}>
            <Box
                component="div"
                sx={{
                    color: "inherit",
                    fontFamily: "inherit",
                    fontSize: "inherit",
                    fontWeight: "inherit",
                    letterSpacing: "inherit",
                    lineHeight: "inherit",
                }}
            >
                {message}
            </Box>
            <LinearProgress
                data-cy={`share-link-download-progress-bar-${snackbarKey}`}
                variant="determinate"
                value={percent}
                sx={{ mt: 1, borderRadius: 999 }}
            />
        </Box>
    )

    function handleProgress(payload = {}) {
        if (payload.key !== snackbarKey) return
        setPercent((current) => Math.max(current, normalizePercent(payload.percent)))
    }
}

function normalizePercent(percent) {
    const numericPercent = Number(percent)
    if (!Number.isFinite(numericPercent)) return 0
    return Math.max(0, Math.min(100, numericPercent))
}
